// @owners { team: patients }
import { get } from 'lodash';
import { prescriptionIsActive } from '~shared/features/my-meds/helper';
import { type Medication } from '~shared/features/my-meds/types';

export default (medication: Medication) => {
  const prescriptions = get(medication, 'prescriptions', []);
  return prescriptions?.some?.((rx) => prescriptionIsActive(rx) && rx.auto_refill) ?? false;
};
